import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VehicleForm from "./vehicleComponents/VehicleForm";

import {
  useGetVehicleDetailQuery,
  useUpdateVehicleMutation,
} from "store/services/vehicleApi";

import { useAppMeta } from "hooks";

const VehicleEditScreen = () => {
  const { id } = useParams(); // Get vehicle ID from the URL parameters

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vehicles", path: "/app/crm/vehicle/list" },
    { title: "Edit Vehicle" },
  ];

  // RTK Query
  const {
    data: vehicleDetail,
    isLoading: loadingVehicle,
    error,
  } = useGetVehicleDetailQuery(id); // Fetch vehicle details using the ID

  const [updateVehicle, { isLoading: updatingVehicle }] =
    useUpdateVehicleMutation(); // Mutation to update vehicle details

  // Update handler
  const handleUpdateVehicle = async (data) => {
    const payload = { id, ...data };

    try {
      await updateVehicle(payload).unwrap();
      toast.success("Vehicle successfully updated!");
      navigate(`/app/crm/vehicle/${id}/detail`); // Redirect to vehicle detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update vehicle!"
      );
    }
  };

  useAppMeta("Edit Vehicle");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingVehicle || updatingVehicle}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <VehicleForm
          isBusy={loadingVehicle || updatingVehicle}
          vehicleDetail={vehicleDetail} // Pass the fetched vehicle details to the form
          onSubmit={handleUpdateVehicle}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleEditScreen;
